(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poiema-app-vitrina"] && !Shopify.designMode) return;
  try {
    
  /* Mejora progresiva del panel de filtros. TODO lo de aqui es opcional: sin
   * JavaScript el panel filtra igual, porque es un <form method="get"> con
   * casillas reales. Lo que esto anade es (a) el buscador dentro de un grupo
   * largo, (b) una salida cuando ese buscador no encuentra nada, y (c) cerrar
   * la hoja movil con Escape.
   *
   * 🔒 El campo de busqueda nace `hidden` en el marcado y solo lo destapa este
   * archivo. Asi nunca existe un control que prometa filtrar sin poder hacerlo,
   * que es la trampa nº1 de este entorno en pequeño. */
  (function () {
    'use strict';

    document.querySelectorAll('[data-pa-grupo]').forEach(function (grupo) {
      var caja = grupo.querySelector('[data-pa-buscador]');
      var campo = grupo.querySelector('[data-pa-campo]');
      var salida = grupo.querySelector('[data-pa-salida]');
      var enlace = grupo.querySelector('[data-pa-salida-enlace]');
      if (!caja || !campo) return;

      var filas = Array.prototype.slice.call(grupo.querySelectorAll('[data-pa-fila]'));
      caja.hidden = false;

      campo.addEventListener('input', function () {
        var q = campo.value.trim().toLowerCase();
        var vistas = 0;

        filas.forEach(function (fila) {
          // Una fila con el filtro YA puesto no se esconde nunca: si se
          // escondiera, el lector no podria quitar el filtro que acaba de
          // poner sin borrar antes lo que escribio.
          var puesta = fila.querySelector('input:checked') !== null;
          var casa = q === '' || (fila.dataset.paTexto || '').indexOf(q) !== -1;
          fila.hidden = !(casa || puesta);
          if (casa) vistas++;
        });

        if (salida && enlace) {
          salida.hidden = !(q !== '' && vistas === 0);
          if (!salida.hidden) {
            enlace.href = enlace.href.split('?')[0] +
              '?q=' + encodeURIComponent(campo.value.trim()) + '&type=product';
          }
        }
      });
    });

    /* La hoja movil es un <details>, no un <dialog>: funciona sin JS, pero no
     * atrapa el foco ni cierra con Escape. Esto le devuelve lo segundo, que es
     * lo barato. Lo primero exigiria un <dialog> y con el la hoja dejaria de
     * abrirse sin JavaScript, que es peor trato. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.pa-filtros__hoja[open]').forEach(function (hoja) {
        // Solo en el ancho donde la hoja es una capa sobre la pagina. En
        // escritorio el cuerpo esta siempre desplegado y cerrarlo no
        // significaria nada.
        if (window.matchMedia('(max-width: 749px)').matches) {
          hoja.removeAttribute('open');
          var disparador = hoja.querySelector('.pa-filtros__disparador');
          if (disparador) disparador.focus();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
